module.exports = __webpack_public_path__ + "static/904902642-wide.40bd09fd.jpg";